import { CheckFilledIcon, ErrorOutlinedIcon } from 'icons';
import { AlertSeverity } from 'modules/alerts/state';

export type SnackbarIconProps = {
  severity: AlertSeverity;
};

export const SnackbarIcon = ({ severity }: SnackbarIconProps) => {
  switch (severity) {
    case 'success':
      return <CheckFilledIcon fontSize="small" color="success" />;
    case 'error':
      return <ErrorOutlinedIcon fontSize="small" color="error" />;
    default:
      return null;
  }
};
